export interface SampleQuestion {
  id: string;
  question: string;
  answer: string;
}

export interface DifficultyLevel {
  key: "easy" | "medium" | "hard" | "veryHard" | "impossible";
  label: string;
  flavor: string;
  questions: SampleQuestion[];
}

export const SAMPLE_QUESTIONS: DifficultyLevel[] = [
  {
    key: "easy",
    label: "Easy",
    flavor:
      "Perfect for newcomers — any wizard would know these.",
    questions: [
      {
        id: "easy-1",
        question: "What is the name of Harry Potter's snowy owl?",
        answer: "Hedwig",
      },
      {
        id: "easy-2",
        question:
          "What is the name of the class at Hogwarts where students learn how to transform things?",
        answer: "Transfiguration",
      },
      {
        id: "easy-3",
        question:
          "Who is the Headmaster of Hogwarts School of Witchcraft and Wizardry?",
        answer: "Albus Dumbledore",
      },
    ],
  },
  {
    key: "medium",
    label: "Medium",
    flavor:
      "Casual fans who know their stuff will have fun with these",
    questions: [
      {
        id: "medium-1",
        question: "What is the name of pub that serves as the entrance to Diagon Alley?",
        answer: "The Leaky Cauldron",
      },
      {
        id: "medium-2",
        question:
          "How many beaters are on a quidditch team?",
        answer: "Two",
      },
      {
        id: "medium-3",
        question:
          "Who is the ghost of Gryffindor tower?",
        answer:
          "Nearly Headless Nick",
      },
    ],
  },
  {
    key: "hard",
    label: "Hard",
    flavor:
      "For dedicated fans who've paid close attention to the finer details of the wizarding world.",
    questions: [
      {
        id: "hard-1",
        question:
          "Where did Malfoy tell Harry and Ron to meet him for the midnight duel?",
        answer: "The Trophy Room",
      },
      {
        id: "hard-2",
        question:
          "Where does Harry first read Nicholas Flamel’s name?",
        answer: "A Chocolate Frog card",
      },
      {
        id: "hard-3",
        question:
          "What plant likes the dark and the damp and cringes away from light and warmth?",
        answer: "Devil's Snare",
      },
    ],
  },
  {
    key: "veryHard",
    label: "Very Hard",
    flavor:
      "Only the most obsessive re-readers and lore enthusiasts will get these without a hint.",
    questions: [
      {
        id: "veryHard-1",
        question: "What is the name of the Centaur who helped Harry escape from danger the first time he entered the Forbidden Forest?",
        answer: "Firenze",
      },
      {
        id: "veryHard-2",
        question:
          "What potion is created when asphodel and wormwood are combined?",
        answer: "Draught of Living Death",
      },
      {
        id: "veryHard-3",
        question:
          "How much does a copy of the Daily Prophet cost?",
        answer: "Five Knuts",
      },
    ],
  },
  {
    key: "impossible",
    label: "Impossible",
    flavor:
      "These are for the real sickos. If you think you know everything and just wish you could still find a challenge - look no further",
    questions: [
      {
        id: "impossible-1",
        question: "How many staircases are there at Hogwarts?",
        answer: "142 staircases",
      },
      {
        id: "impossible-2",
        question:
          "According to Quidditch Through The Ages, how many ways are there of committing a quidditch foul?",
        answer:
          "700",
      },
      {
        id: "impossible-3",
        question:
          "	Who plays seeker for Slytherin during Harry's first year?",
        answer:
          "Terence Higgs",
      },
    ],
  },
];